/**
 * User-facing Turnstile copy, shared by every surface that mounts the widget.
 *
 * Lives here rather than in `QuizLoadingSplash.tsx` (where the interactive message
 * started) so `AuthModal` can use it without importing from a quiz component.
 */

/**
 * Shown instead of a whimsical phrase while an escalated Turnstile checkbox is
 * waiting for the user — the checkbox renders below the phrase (see
 * `extraContent`), so the copy must tell the user to click it, not read as a
 * loading message it can hide under. "Below" matches that placement.
 */
export const TURNSTILE_INTERACTIVE_MESSAGE =
  "Quick security check: please confirm you're human below.";

/**
 * The widget never rendered (Cloudflare's script didn't load, or `render()` produced
 * nothing), so no challenge was ever dispatched. Distinct from "timed out": a timeout
 * means a challenge ran and didn't come back, and retrying can help — here only a
 * fresh page load can, so the copy says so.
 */
export const TURNSTILE_UNAVAILABLE_MESSAGE =
  "Security check couldn't load. Please reload the page and try again.";
